import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { API_KEY, BASE_URL } from "./config";

Modal.setAppElement('#root');

function HedgeToSignalConversionModal({ isOpen, closeModal, symbolData }) {
    const [formData, setFormData] = useState({
      signalRequestId: symbolData.signalRequestId || null,
      symbol: symbolData.symbol || '',
      side: symbolData.side || '',
      marginCoin: symbolData.marginCoin || '',
      orderType: 'market', // default value
      limitPrice: '', // to be fetched from backend
      closurePercentage: '100', // Default value
      hedgeSLCallbackRate: '1.5',
    });
  

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [submissionResult, setSubmissionResult] = useState(null);

  const [showDropdown, setShowDropdown] = useState(true);

  const toggleInputType = () => {
    setShowDropdown(!showDropdown);
    if (!showDropdown) {
      // Reset to a default value when switching back to dropdown
      setFormData({ ...formData, closurePercentage: '50' });
    }
  };



  useEffect(() => {
    // Fetch the current market price for the symbol and set it as default for limitPrice
    const fetchMarketPrice = async () => {
      // Replace with your actual backend API endpoint
      const response = await fetch(`/api/bot/get/getMarkPriceBySymbol?symbol=${formData.symbol}`,
                      {
                        headers: {
                          "X-SIGNALFLY-KEY": API_KEY
                        }
                      });
      const data = await response.json();
      setFormData(prevFormData => ({ ...prevFormData, limitPrice: data.markPrice }));
    };

    if (formData.symbol) {
      fetchMarketPrice();
    }
  }, [formData.symbol]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    closeRepelTradeHedgePositionPost(formData);
  };

  const closeRepelTradeHedgePositionPost = (formSubmittedData) => {
    setLoading(true);
    fetch('/api/bot/ui/post/convertHedgeToSignalPosition', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "X-SIGNALFLY-KEY": API_KEY
      },
      body: JSON.stringify(formSubmittedData),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setSubmissionResult(data);
      setLoading(false);
    })
    .catch(error => {
      setError(error.message);
      setLoading(false);
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Hedge To Signal Conversion Parameters"
      className="ReactModal__Content"
      overlayClassName="ReactModal__Overlay"
    >
      <button className="modal-close-button" onClick={closeModal}>&times;</button>
      <h2 className="page-title">Hedge To Signal Conversion Parameters</h2>
      <br/>
      {loading && <div className="loading-message">Loading...</div>}
      {error && <div>Error: {error}</div>}
      {submissionResult && <div>Result: {JSON.stringify(submissionResult)}</div>}

      {!loading && !submissionResult && (
        <form className="modal-form" onSubmit={handleSubmit}>
        <label>
          Signal Request ID:
          <input
            type="text"
            name="signalRequestId"
            value={formData.signalRequestId}
            readOnly
          />
        </label>
        <label>
          Symbol:
          <input
            type="text"
            name="symbol"
            value={formData.symbol}
            readOnly
          />
        </label>
        <label>
          Signal Side: 
          <input
            type="text"
            name="side"
            value={formData.side}
            readOnly
          />
        </label>
        <label>
          Order Type:
          <select
            name="orderType"
            value={formData.orderType}
            onChange={handleInputChange}
          >
            <option value="limit">Limit</option>
            <option value="market">Market</option>
          </select>
        </label>
        <label>
          Limit Price:
          <input
            type="text"
            name="limitPrice"
            value={formData.limitPrice}
            onChange={handleInputChange}
          />
        </label>
        <label>
          Closure Percentage:
          {showDropdown ? (
            <select
              name="closurePercentage"
              value={formData.closurePercentage}
              onChange={handleInputChange}
            >
              <option value="100">100%</option>
            </select>
          ) : (
            <input
              type="number"
              name="closurePercentage"
              value={formData.closurePercentage}
              onChange={handleInputChange}
              max="100"
              required
            />
          )}
          <button type="button" onClick={toggleInputType}>
            {showDropdown ? 'Type Manually' : 'Select '}
          </button>
        </label>       
        <label>
           Trailing SL callback rate:
          <select
            name="hedgeSLCallbackRate"
            value={formData.hedgeSLCallbackRate}
            onChange={handleInputChange}
          >
                        <option value="0.1">0.1%</option>
                        <option value="0.2">0.2%</option>
                        <option value="0.3">0.3%</option>
                        <option value="0.4">0.4%</option>
                        <option value="0.5">0.5%</option>
                        <option value="1">1%</option>
                        <option value="1.25">1.25%</option>
                        <option value="1.5">1.5%</option>
                        <option value="2">2%</option>
                        <option value="2">3%</option>
          </select>
        </label>    
        <div className="modal-button-container">
          <button type="submit">Submit</button>
          <button type="button" onClick={closeModal}>Cancel</button>
        </div>
      </form>
      )}
    </Modal>
  );
}

export default HedgeToSignalConversionModal;


